<template>
  <vx-card no-shadow>
    <!-- Img Row -->
     <div class="vx-row mb-5">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img class="mr-8 rounded h-24 w-24" :src="company.image" size="80px"  />
          <!-- <vs-avatar :src="employee.user.image" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
            <input type="file" class="hidden" ref="update_avatar_input" name="imagem"  @change="previewImage" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mr-4 mb-4"  @click="$refs.update_avatar_input.click()">Carregar foto</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button v-if="imagem!==''" type="border" size="small" color="primary" @click="saveProfilePicture">
              
              <i class="fas fa-sync fa-2x"></i>
            
             
              </vs-button>
            <p v-if="process==false" class="text-sm mt-2">Formatos suportados JPG, JPEG or PNG.</p>
           <p v-if="process==true"> <vs-progress indeterminate color="primary"></vs-progress></p>
          </div>
        </div>
      </div>
    </div>

<div class="vx-col w-full mb-base">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="text-sm font-bold">Nome da empresa</label>
            <div class="vx-col w-full">
              <vs-input
              disabled
                class="w-full"
                icon-pack="feather"
                icon="icon-home"
                icon-no-border
                v-model="company.name"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Endereco</label>
            <div class="vx-col w-full">
              <vs-input
              
                class="w-full"
                icon-pack="feather"
                icon="icon-map-pin"
                icon-no-border
                v-model="company.address"
              />
            </div>
          </div>
        </div>
  <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="text-sm font-bold">Email</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-mail"
                icon-no-border
                v-model="company.email"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Telefone</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-smartphone"
                icon-no-border
                v-model="contact.phone"
              />
            </div>
          </div>
        </div>
         <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="text-sm font-bold">INSS</label>
            <div class="vx-col w-full">
              <vs-input
              disabled
                class="w-full"
                icon-pack="feather"
                icon="icon-file-minus"
                icon-no-border
                v-model="company.inss"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Nuit</label>
            <div class="vx-col w-full">
              <vs-input
              disabled
                class="w-full"
                icon-pack="feather"
                icon="icon-file-minus"
                icon-no-border
                v-model="company.nuit"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="text-sm font-bold">Responsavel da empresa</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-user"
                icon-no-border
                v-model="company.responsible_name"
              />
            </div>
          </div>
          
        </div>
      
        
        
</div>
    
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="updateComapny">Actualizar</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Repor</vs-button> -->
    </div>
  </vx-card>
</template>

<script>
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
export default {
  mixins:[PermissionsMixin],
  data() {
    return {
      contact:[
        {
          id:"",
          phone:""
        }
      ],
      company: [],
      imagem:"",
      process:false,
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },


  },

mounted(){
this.initialize()
},

  
    methods: {

      previewImage(event) {
            this.imagem = event.target.files[0]
        },

      initialize(){
        this.getData()
      },


          getData() {
            this.$vs.loading()
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
     

      http
        .get("/companies/companies", config)
        .then((result) => {
          this.$vs.loading.close();
          this.company = result.data;
          this.contact.phone= result.data.contacts[0].phone
          this.contact.id=result.data.contacts[0].id
          

        })
        .catch((error) => {
          this.$vs.loading.close();
          error;
        });
    },


     async saveProfilePicture() {
    this.process=true;
      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
      const data = new FormData();
  data.append('image', this.imagem);
  data.append("company_id", this.company.id) 



      this.$validator.validateAll();
      await http
        .post("/companies/upload_photo", data, config)
        .then((success) => {
          this.getData(),
          this.process=false;
          this.imagem="",
          success;
        
          this.$vs.notify({
            title: "Sucesso",
            text: "Foto de perfil actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.process=false;
          this.$vs.notify({
            title: "Erro",
            text: "falha ao Foto de perfil ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
 


 async updateComapny() {
        this.$vs.loading()
     setTimeout( ()=> {
        this.$vs.loading.close()
      }, 2000);
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
        

          name:this.company.name,
          address:this.company.address,
            inss:this.company.inss,
           nuit:this.company.nuit,
           phone:this.contact.phone,
           responsible_name:this.company.responsible_name,
           phone_id:this.contact.id,
            email:this.company.email,

            
            

          


          
      };

      this.$validator.validateAll();
      await http
        .put(`/companies/companies/${this.company.id}`, data, config)
        .then((success) => {
          success;
        this.popupWorkExperience=false,
        this.$vs.loading.close();
        this.getData(),
          this.$vs.notify({
            title: "Sucesso",
            text: "Empresa actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==422 ){
          this.err= error.response.data
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },

    },
}
</script>
